// © Thibault Sabathier, 2025. Tous droits réservés.
// frontend/src/components/messaging/ConversationIcebreaker.js
//
// Icebreaker en tête de fil d'une conversation 1:1 : "❤️ Vous partagez : 🤖 IA · 🥾 Randonnée".
// Sprint 2 centres d'intérêt. Affiché UNIQUEMENT s'il y a ≥1 intérêt commun
// (jamais "aucun intérêt commun" = effet inverse). Max 3, tri alphabétique (V1).
// Placé dans la zone scrollable → prominent sur conv vide, scrolle sur conv longue.
// Architecture extensible : on pourra plus tard ajouter ville/filière/promo/entreprise
// communes dans le même bloc sans rien changer au placement.

import React, { useEffect, useMemo, useState } from 'react'
import CIcon from '@coreui/icons-react'
import { cilHeart } from '@coreui/icons'
import interestsService from '../../services/interestsService'

const MAX = 3

const ConversationIcebreaker = ({ otherMemberId }) => {
  const [common, setCommon] = useState([])
  const [emojis, setEmojis] = useState({})

  // Intérêts en commun (best-effort, silencieux).
  useEffect(() => {
    if (!otherMemberId) {
      setCommon([])
      return undefined
    }
    let cancelled = false
    interestsService
      .getCommonInterests(otherMemberId)
      .then((list) => {
        if (!cancelled) setCommon(Array.isArray(list) ? list : [])
      })
      .catch(() => {
        if (!cancelled) setCommon([])
      })
    return () => {
      cancelled = true
    }
  }, [otherMemberId])

  // slug → emoji (taxonomie cachée).
  useEffect(() => {
    let cancelled = false
    interestsService
      .getTaxonomy()
      .then((data) => {
        if (cancelled || !data?.interests) return
        const m = {}
        for (const it of data.interests) if (it.emoji) m[it.slug] = it.emoji
        setEmojis(m)
      })
      .catch(() => {})
    return () => {
      cancelled = true
    }
  }, [])

  const shown = useMemo(
    () => [...common].sort((a, b) => a.label.localeCompare(b.label)).slice(0, MAX),
    [common],
  )

  if (!shown.length) return null // Cas "0 commun" → rien (jamais de message négatif).

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: '0.4rem',
        padding: '0.5rem 0.75rem',
        margin: '0.25rem 0 0.5rem',
        background: '#f0fdf4',
        border: '1px solid #bbf7d0',
        borderRadius: '10px',
        fontSize: '0.82rem',
        color: '#15803d',
      }}
    >
      <CIcon icon={cilHeart} size="sm" style={{ color: '#16a34a' }} />
      <span style={{ fontWeight: 600 }}>Vous partagez&nbsp;:</span>
      {shown.map((it) => (
        <span
          key={it.id}
          style={{
            background: '#dcfce7',
            borderRadius: '999px',
            padding: '0.15rem 0.55rem',
            fontWeight: 500,
            whiteSpace: 'nowrap',
          }}
        >
          {emojis[it.slug] ? `${emojis[it.slug]} ` : ''}
          {it.label}
        </span>
      ))}
    </div>
  )
}

export default ConversationIcebreaker
